import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

const PrivacyControl = () => {
  const analyticsCookie = 'ga-disable-G-HQTMLQ947D';
  const cookies = new Cookies();
  const [showAnnouncement, setShowAnnouncement] = useState(!localStorage.getItem("cookieConsent"));

  useEffect(() => {
    if (cookies.get(analyticsCookie) === null || cookies.get(analyticsCookie) === undefined) {
      cookies.set(analyticsCookie, false);
    }
  }, []);

  return (
    <div className='privacy-control-wrapper'
    >
      {showAnnouncement &&
        <div>
          <div>
            <Typography variant="h5" className='consent-title'>Consent Notice</Typography>
            <Typography variant="body1" className="p-5">
            This website utilizes cookies to enhance site navigation, analyze site usage, and personalize your experience. By clicking "Accept All", you consent to our use of cookies.
            </Typography>
            <div id="button-wrapper">
              <Button type="button" className="button-primary mx-2 h-10" size="small"
                onClick={() => {
                  cookies.set(analyticsCookie, false);
                  localStorage.setItem("cookieConsent", "true");
                  setShowAnnouncement(false)
                }
                }>Accept All</Button>
              <Button type="button" className="button-primary h-10" size="small"
                onClick={() => {
                  cookies.set(analyticsCookie, true);
                  localStorage.setItem("cookieConsent", "false");
                  setShowAnnouncement(false)
                }
                }>Decline All</Button>
            </div>
          </div>
        </div>}
    </div>
  );
};

export default PrivacyControl;
